/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RunYieldsList_runYieldEdges$ref: FragmentReference;
declare export opaque type RunYieldsList_runYieldEdges$fragmentType: RunYieldsList_runYieldEdges$ref;
export type RunYieldsList_runYieldEdges = $ReadOnlyArray<{|
  +totalItemQuantity: number,
  +node: {|
    +id: string,
    +item: {|
      +id: string,
      +name: string,
      +quantityUOM: {|
        +id: string,
        +symbol: string,
      |},
    |},
  |},
  +$refType: RunYieldsList_runYieldEdges$ref,
|}>;
export type RunYieldsList_runYieldEdges$data = RunYieldsList_runYieldEdges;
export type RunYieldsList_runYieldEdges$key = {
  +$data?: RunYieldsList_runYieldEdges$data,
  +$fragmentRefs: RunYieldsList_runYieldEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "RunYieldsList_runYieldEdges",
  "type": "RunYieldEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalItemQuantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "JobYield",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "item",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "quantityUOM",
              "storageKey": null,
              "args": null,
              "concreteType": "UOM",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "symbol",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '3a7a50a9803a6f58872860d61c1c51f9';
module.exports = node;
